"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    id: "uuid-734d1732-5e40-4afd-a486-a92072e38ce2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 408.02 412.5",
    width: "100%",
    height: "100%",
    children: [(0, jsx_runtime_1.jsxs)("g", {
      children: [(0, jsx_runtime_1.jsx)("circle", {
        cx: "132.2",
        cy: "250.75",
        r: "6.49",
        fill: "currentColor"
      }), (0, jsx_runtime_1.jsx)("circle", {
        cx: "140.38",
        cy: "270.48",
        r: "6.49",
        fill: "currentColor"
      }), (0, jsx_runtime_1.jsx)("circle", {
        cx: "148.64",
        cy: "290.44",
        r: "6.49",
        fill: "currentColor"
      }), (0, jsx_runtime_1.jsx)("circle", {
        cx: "156.82",
        cy: "310.17",
        r: "6.49",
        fill: "currentColor"
      }), (0, jsx_runtime_1.jsx)("circle", {
        cx: "165.04",
        cy: "330.02",
        r: "6.49",
        fill: "currentColor"
      }), (0, jsx_runtime_1.jsx)("circle", {
        cx: "173.21",
        cy: "349.75",
        r: "6.49",
        fill: "currentColor"
      })]
    }), (0, jsx_runtime_1.jsxs)("g", {
      children: [(0, jsx_runtime_1.jsx)("circle", {
        cx: "230.75",
        cy: "250.75",
        r: "6.49",
        fill: "currentColor"
      }), (0, jsx_runtime_1.jsx)("circle", {
        cx: "222.58",
        cy: "270.48",
        r: "6.49",
        fill: "currentColor"
      }), (0, jsx_runtime_1.jsx)("circle", {
        cx: "214.31",
        cy: "290.44",
        r: "6.49",
        fill: "currentColor"
      }), (0, jsx_runtime_1.jsx)("circle", {
        cx: "206.14",
        cy: "310.17",
        r: "6.49",
        fill: "currentColor"
      }), (0, jsx_runtime_1.jsx)("circle", {
        cx: "197.92",
        cy: "330.02",
        r: "6.49",
        fill: "currentColor"
      }), (0, jsx_runtime_1.jsx)("circle", {
        cx: "189.75",
        cy: "349.75",
        r: "6.49",
        fill: "currentColor"
      })]
    }), (0, jsx_runtime_1.jsxs)("g", {
      children: [(0, jsx_runtime_1.jsx)("circle", {
        cx: "181.48",
        cy: "240.95",
        r: "6.49",
        fill: "currentColor"
      }), (0, jsx_runtime_1.jsx)("circle", {
        cx: "181.48",
        cy: "219.47",
        r: "6.49",
        fill: "currentColor"
      }), (0, jsx_runtime_1.jsx)("circle", {
        cx: "181.48",
        cy: "262.31",
        r: "6.49",
        fill: "currentColor"
      }), (0, jsx_runtime_1.jsx)("circle", {
        cx: "181.48",
        cy: "283.91",
        r: "6.49",
        fill: "currentColor"
      }), (0, jsx_runtime_1.jsx)("circle", {
        cx: "181.48",
        cy: "305.27",
        r: "6.49",
        fill: "currentColor"
      }), (0, jsx_runtime_1.jsx)("circle", {
        cx: "181.48",
        cy: "326.75",
        r: "6.49",
        fill: "currentColor"
      })]
    }), (0, jsx_runtime_1.jsxs)("g", {
      children: [(0, jsx_runtime_1.jsx)("circle", {
        cx: "242.15",
        cy: "309.11",
        r: "6.49",
        fill: "currentColor"
      }), (0, jsx_runtime_1.jsx)("circle", {
        cx: "227.04",
        cy: "324.22",
        r: "6.49",
        fill: "currentColor"
      }), (0, jsx_runtime_1.jsx)("circle", {
        cx: "211.86",
        cy: "339.4",
        r: "6.49",
        fill: "currentColor"
      })]
    }), (0, jsx_runtime_1.jsxs)("g", {
      children: [(0, jsx_runtime_1.jsx)("circle", {
        cx: "241.07",
        cy: "345.12",
        r: "6.49",
        fill: "currentColor"
      }), (0, jsx_runtime_1.jsx)("circle", {
        cx: "221.22",
        cy: "353.34",
        r: "6.49",
        fill: "currentColor"
      }), (0, jsx_runtime_1.jsx)("circle", {
        cx: "201.49",
        cy: "361.51",
        r: "6.49",
        fill: "currentColor"
      })]
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M179.42,383.31c-1.4,0-2.81-.37-4.09-1.13l-67.95-40.57c-3.79-2.27-5.03-7.18-2.77-10.97,2.27-3.79,7.18-5.03,10.97-2.77l67.95,40.57c3.79,2.27,5.03,7.18,2.77,10.97-1.5,2.51-4.15,3.9-6.88,3.9Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsxs)("g", {
      children: [(0, jsx_runtime_1.jsx)("path", {
        d: "M278.38,360.48c.09-.09,.17-.19,.26-.28-.09,.09-.17,.19-.26,.28Z",
        fill: "currentColor"
      }), (0, jsx_runtime_1.jsx)("path", {
        d: "M212.47,97.69c-1.53-.34-3.11-.53-4.73-.53h-50.43c-1.62,0-3.2,.19-4.73,.53-10.3,2.31-18.06,11.99-18.06,23.55,0,13.28,10.23,24.08,22.8,24.08h50.43c12.57,0,22.79-10.8,22.79-24.08,0-11.56-7.76-21.24-18.06-23.55Zm-4.73,33.56h-50.43c-5.23,0-9.48-4.49-9.48-10.01s4.25-10.01,9.48-10.01h50.43c5.23,0,9.48,4.49,9.48,10.01s-4.25,10.01-9.48,10.01Z",
        fill: "currentColor"
      }), (0, jsx_runtime_1.jsx)("path", {
        d: "M108.39,230.75c0-2.91-1.8-5.53-4.52-6.57-2.73-1.04-5.81-.29-7.75,1.88-6.67,7.45-28.46,32.8-28.84,46.32-.17,5.99,3.51,13.91,31.3,31.18,1.2,.75,2.4,1.48,3.6,2.2,6.94,4.2,13.56,7.89,18.27,10.45,0,0,8.53,4.55,11.29,8.44,1.68,2.37,2.84,5.15,3.29,8.15l13.71,8.87c.37-1.97,.57-4,.57-6.08,0-10.85-5.29-20.47-13.39-26.49-.6-.71-1.32-1.31-2.17-1.75-9.21-4.73-18.13-9.77-25.92-14.57,.37-.85,.58-1.8,.58-2.79v-59.23Zm-14.06,53.17c-7.08-5.01-11.85-9.19-12.95-11.6,.5-3.94,5.97-12.69,12.95-21.94v33.54Z",
        fill: "currentColor"
      }), (0, jsx_runtime_1.jsx)("path", {
        d: "M400.99,370.59h-35.43c.02-31.83,.03-75.76-.02-88.3-.06-12.97-17.73-41.19-32.54-62.58-14.71-21.24-34.22-46.43-42.31-51.56-9.46-6-34.94-6.13-52.29-5.43,4.78-13.76,8.68-29.41,10.74-38.29,4.66-20.09,11.65-55.18,6.08-64.49-2.17-3.62-6.21-7.5-11.69-11.31C241.35,21.5,214.83,0,182.53,0s-58.82,21.5-60.99,48.62c-5.48,3.81-9.52,7.69-11.69,11.31-5.57,9.31,1.42,44.4,6.08,64.49,2.06,8.88,5.96,24.52,10.73,38.27-17.33-.68-42.43-.5-51.8,5.45C60.89,177,.1,259.31,0,282.29c-.03,7.7,5.7,20.44,50.74,50.84,18.14,12.25,36.46,23.13,44.26,27.67,5.75,4.86,13.17,7.81,21.28,7.81,6.63,0,12.8-1.97,17.98-5.35l-14.1-9.12c-1.25,.26-2.55,.4-3.88,.4s-2.51-.13-3.72-.37c-4.85-.97-12.44-6.67-12.44-6.67-4.03-2.37-9.94-5.88-16.78-10.11-7.38-4.56-15.87-9.95-24.34-15.66-43.99-29.65-44.92-39.02-44.94-39.39,.02-5.64,9.32-24.72,30.04-54.64,18.62-26.88,34.46-45.27,38.28-47.7,5.43-3.45,28.5-4.15,50.02-2.97,2.32,4.84,4.74,8.71,7.18,10.85,10.43,9.14,27.7,12.57,37.6,13.83,1.33,.07,9.59,.21,10.67,0,9.9-1.26,27.16-4.69,37.6-13.83,2.43-2.13,4.85-5.99,7.17-10.82,21.65-1.21,45.04-.53,50.52,2.94,3.83,2.43,19.66,20.81,38.28,47.7,20.72,29.92,30.02,49,30.04,54.64,.06,12.52,.04,56.43,.02,88.24,0,5.05,0,9.79,0,14.06,0,5.52,0,10.24,0,13.79h-44.9c.03-3.57,.06-8.31,.1-13.79,.03-4.29,.06-9.04,.09-14.06,0-.4,0-.79,0-1.19,.03-4.12,.05-8.41,.08-12.76,0,0-17.66,15.14-17.75,15.21l-.05,.04h0c-1.34,1.05-3.02,1.68-4.85,1.68-4.34,0-7.85-3.51-7.85-7.85,0-2.02,.77-3.86,2.03-5.25,.08-.1,.17-.19,.26-.28,.02-.02,.05-.04,.07-.07,.1-.1,28.26-24.44,28.26-24.44,.03-5.7,.05-11.22,.06-16.29,.03-12.58,.02-22.44-.07-25.78-.12-4.38-2.4-12.83-19.06-39.55-8.88-14.25-17.85-27.19-17.94-27.32-1.75-2.53-4.94-3.62-7.88-2.7-2.93,.92-4.93,3.64-4.93,6.71v106.99c0,3.88,3.15,7.03,7.03,7.03,1.48,0,2.86-.46,3.99-1.24,.6-.74,1.27-1.44,1.99-2.11,.66-1.07,1.05-2.33,1.05-3.68v-83.78c11.67,18.16,21.44,35.37,21.69,40.06,.12,4.13,.1,19.02,.03,36.63l-22.41,19.36c-.12,.11-.23,.23-.35,.34-.73,.66-1.39,1.36-1.99,2.11-4.17,5.14-5.32,12.02-3.3,18.14H34.85c-3.88,0-7.03,3.15-7.03,7.03s3.15,7.03,7.03,7.03H292.61c-.08,12.08-.15,20.48-.15,20.76-.01,1.87,.72,3.68,2.04,5.01,1.32,1.33,3.12,2.08,4.99,2.08h59.01c3.88,0,7.03-3.14,7.03-7.03,0-.29,0-8.59,.02-20.82h35.44c3.88,0,7.03-3.15,7.03-7.03s-3.15-7.03-7.03-7.03ZM182.53,14.06c20.39,0,37.79,10.55,44.32,25.27-17.84-7.99-37.13-8.34-44.33-8.13-7.21-.2-26.48,.15-44.31,8.13,6.53-14.71,23.93-25.27,44.32-25.27Zm40.57,149.56c-2.08,5.45-3.88,9.25-5.26,11.51-.65,1.06-1.2,1.79-1.65,2.18-8.13,7.12-25.12,10.04-33.67,10.84-8.55-.81-25.54-3.72-33.67-10.84-.4-.35-.88-.97-1.44-1.85-1.4-2.21-3.28-6.12-5.47-11.87-3.4-8.91-7.56-22.21-11.86-40.4-7.5-31.71-9.2-52.11-8.02-56.26,.29-.44,.72-.97,1.28-1.58,2.04-2.19,5.96-5.4,12.38-9.02,2.13-1.2,4.52-2.45,7.23-3.72,13.26-6.22,38.44-7.29,39.52-7.33,1.12,.03,26.33,1.09,39.63,7.33,2.71,1.27,5.1,2.52,7.23,3.72,6.42,3.62,10.34,6.83,12.38,9.02,.56,.61,.99,1.14,1.28,1.58,1.18,4.15-.52,24.55-8.02,56.26-4.31,18.21-8.47,31.53-11.88,40.44Z",
        fill: "currentColor"
      }), (0, jsx_runtime_1.jsx)("path", {
        d: "M289.05,371.9s.01-.02,0,0h0Z",
        fill: "currentColor"
      })]
    })]
  });
};

exports.default = Icon;